import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";
import { modalController } from '@ionic/vue';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import router, { SIBTIME_MOMENTS_PATH } from '@/router';
import AppVideoPlayer from '@/components/AppVideoPlayer.vue';
import useSibTimeMoments from '@/composables/global/use-sibtime-moments';
export default /*#__PURE__*/_defineComponent({
  __name: 'SibtimeMomentsNotification',
  props: {
    sibTimeMoment: {},
    specificModule: {}
  },
  setup(__props) {
    const props = __props;
    const {
      locale,
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          SibtimeMomentsNotification: {
            changePreferences: 'Change your SibTime preferences here',
            sibtimeMoments: 'SibTime Moments',
            submit: 'Submit',
            turnOnSound: 'Please turn on your sound to hear the narration'
          }
        },
        es: {
          SibtimeMomentsNotification: {
            changePreferences: 'Cambie sus preferencias de SibTime aquí',
            sibtimeMoments: 'Momentos de SibTime',
            submit: 'Enviar',
            turnOnSound: 'Por favor, encienda el sonido para escuchar la narración'
          }
        }
      }
    });
    const feedback = ref('');
    const showFeedback = ref(false);
    const {
      getMomentDownloadURL,
      updateUserMoments
    } = useSibTimeMoments();
    const momentFeedbackUrl = ref('');
    const momentText = computed(() => {
      return locale.value === 'es' ? props.sibTimeMoment.textEs : props.sibTimeMoment.text;
    });
    function closeModal() {
      modalController.dismiss();
    }
    async function submitFeedback() {
      showFeedback.value = true;
      let url;
      if (locale.value === 'es') {
        url = feedback.value === 'happy' ? props.sibTimeMoment.positiveFeedbackEs : props.sibTimeMoment.negativeFeedbackEs;
      } else {
        url = feedback.value === 'happy' ? props.sibTimeMoment.positiveFeedbackEn : props.sibTimeMoment.negativeFeedbackEn;
      }
      momentFeedbackUrl.value = await getMomentDownloadURL(url);
      updateUserMoments(props.sibTimeMoment.id, props.specificModule);
    }
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_grid = _resolveComponent("ion-grid");
      const _component_ion_header = _resolveComponent("ion-header");
      const _component_ion_img = _resolveComponent("ion-img");
      const _component_ion_content = _resolveComponent("ion-content");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ion_header, null, {
        default: _withCtx(() => [_createVNode(_component_ion_grid, {
          class: "ion-no-padding"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_row, {
            class: "ion-justify-content-end"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_buttons, null, {
                default: _withCtx(() => [_createVNode(_component_ion_button, {
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [_createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: "close",
                    color: "primary"
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [_createVNode(_component_ion_grid, {
          class: "ion-no-padding ion-margin-horizontal"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_row, {
            class: "ion-justify-content-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_img, {
                src: "/assets/mysibtime/image/sibtime-moments.png",
                class: "sibtime-logo"
              })]),
              _: 1
            })]),
            _: 1
          }), !showFeedback.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_ion_row, {
            class: "ion-justify-content-center ion-padding"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createElementVNode("h2", null, _toDisplayString(_unref(t)('SibtimeMomentsNotification.sibtimeMoments')), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_ion_row, {
            class: "ion-justify-content-center ion-padding"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, null, {
              default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(momentText.value), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_ion_row, {
            class: "ion-justify-content-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = $event => feedback.value = 'happy'),
                mode: "md",
                fill: "clear",
                size: "large"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  icon: "happy-face",
                  slot: "icon-only",
                  color: feedback.value === 'happy' ? 'menu-icon' : 'primary',
                  class: "rating-face"
                }, null, 8, ["color"])]),
                _: 1
              }), _createVNode(_component_ion_button, {
                onClick: _cache[1] || (_cache[1] = $event => feedback.value = 'neutral'),
                mode: "md",
                fill: "clear",
                size: "large"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  icon: "neutral-face",
                  size: "large",
                  slot: "icon-only",
                  color: feedback.value === 'neutral' ? 'menu-icon' : 'primary',
                  class: "rating-face"
                }, null, 8, ["color"])]),
                _: 1
              }), _createVNode(_component_ion_button, {
                onClick: _cache[2] || (_cache[2] = $event => feedback.value = 'sad'),
                mode: "md",
                fill: "clear",
                size: "large"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  icon: "sad-face",
                  size: "large",
                  slot: "icon-only",
                  color: feedback.value === 'sad' ? 'menu-icon' : 'primary',
                  class: "rating-face"
                }, null, 8, ["color"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_ion_row, {
            class: "ion-padding"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, null, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                expand: "block",
                onClick: submitFeedback,
                disabled: !feedback.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('SibtimeMomentsNotification.submit')), 1)]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })]),
            _: 1
          })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_ion_row, {
            class: "ion-justify-content-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(_unref(t)('SibtimeMomentsNotification.turnOnSound')), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [_createVNode(_component_ion_col, null, {
              default: _withCtx(() => [_createVNode(AppVideoPlayer, _mergeProps({
                forceDefaultPlayer: "",
                autoplay: ""
              }, {
                src: momentFeedbackUrl.value
              }), null, 16)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_ion_row, {
            class: "ion-justify-content-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_col, {
              size: "auto"
            }, {
              default: _withCtx(() => [_createElementVNode("button", {
                class: "link-button ion-padding-vertical",
                onClick: _cache[3] || (_cache[3] = $event => (closeModal(), _unref(router).push(_unref(SIBTIME_MOMENTS_PATH))))
              }, _toDisplayString(_unref(t)('SibtimeMomentsNotification.changePreferences')), 1)]),
              _: 1
            })]),
            _: 1
          })], 64))]),
          _: 1
        })]),
        _: 1
      })], 64);
    };
  }
});